import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

function About() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide spinner after component mounts
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      <Header />
      
      {/* Spinner Start */}
      {isLoading && (
        <div
          id="spinner"
          className="bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {/* Spinner End */}

      {/* Page Header Start */}
      <div className="container-fluid bg-primary py-5 bg-header" style={{marginBottom: "90px"}}>
        <div className="row py-5">
          <div className="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 className="display-4 text-white animated zoomIn">About Us</h1>
            <a href="/" className="h5 text-white">Home</a>
            <i className="far fa-circle text-white px-2"></i>
            <a href="/about" className="h5 text-white">About</a>
          </div>
        </div>
      </div>
      {/* Page Header End */}
      {/* About Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                <h1 className="mb-0">
                  Offering Digital Marketing Solutions with 8+ Years of Experience
                </h1>
              </div>
              <p className="mb-4 fs-5">
                Welcome to Brand Lift, we are your trusted advisors and a
                leading team of branding experts, we understand the complexities
                of the digital world and ensure that your business grows with our
                tailored solutions that suit your unique goals.
              </p>
              <div className="row g-0 mb-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Award Winning
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Professional
                    Staff
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>24/7 Support
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Fair Prices
                  </h5>
                </div>
              </div>
              <div
                className="d-flex align-items-center mb-4 wow fadeIn"
                data-wow-delay="0.6s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{width: "60px", height: "60px"}}
                >
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="mb-2">Call to ask any question</h5>
                  <h4 className="text-primary mb-0">+971 55 730 6504</h4>
                </div>
              </div>
              <a
                href="/free-quote"
                className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
                data-wow-delay="0.9s"
              >Request A Quote</a>
            </div>
            <div className="col-lg-5" style={{minHeight: "500px"}}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src="/img/about us (440 x 543).jpg"
                  alt="About Us"
                  style={{objectFit: "cover"}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}

      {/* Team Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{maxWidth: "600px"}}
          >
            <h5 className="fw-bold text-primary text-uppercase">Team Members</h5>
            <h1 className="mb-0">Professional Stuffs Ready to Help Your Business</h1>
          </div>
          <div className="row g-5">
            <div className="col-lg-3 wow slideInUp" data-wow-delay="0.3s">
              <div className="team-item bg-light rounded overflow-hidden">
                <div className="team-img position-relative overflow-hidden">
                  <img
                    className="img-fluid w-100"
                    src="/img/team-1.jpg"
                    alt="Team Member 1"
                  />
                  <div className="team-social">
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-twitter fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-facebook-f fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-instagram fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-linkedin-in fw-normal"></i></a>
                  </div>
                </div>
                <div className="text-center py-4">
                  <h4 className="text-primary">Full Name</h4>
                  <p className="text-uppercase m-0">Designation</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow slideInUp" data-wow-delay="0.6s">
              <div className="team-item bg-light rounded overflow-hidden">
                <div className="team-img position-relative overflow-hidden">
                  <img
                    className="img-fluid w-100"
                    src="/img/team-2.jpg"
                    alt="Team Member 2"
                  />
                  <div className="team-social">
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-twitter fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-facebook-f fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-instagram fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-linkedin-in fw-normal"></i></a>
                  </div>
                </div>
                <div className="text-center py-4">
                  <h4 className="text-primary">Full Name</h4>
                  <p className="text-uppercase m-0">Designation</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow slideInUp" data-wow-delay="0.9s">
              <div className="team-item bg-light rounded overflow-hidden">
                <div className="team-img position-relative overflow-hidden">
                  <img
                    className="img-fluid w-100"
                    src="/img/team-3.jpg"
                    alt="Team Member 3"
                  />
                  <div className="team-social">
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-twitter fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-facebook-f fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-instagram fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-linkedin-in fw-normal"></i></a>
                  </div>
                </div>
                <div className="text-center py-4">
                  <h4 className="text-primary">Full Name</h4>
                  <p className="text-uppercase m-0">Designation</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow slideInUp" data-wow-delay="0.9s">
              <div className="team-item bg-light rounded overflow-hidden">
                <div className="team-img position-relative overflow-hidden">
                  <img
                    className="img-fluid w-100"
                    src="/img/team-1.jpg"
                    alt="Team Member 4"
                  />
                  <div className="team-social">
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-twitter fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-facebook-f fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-instagram fw-normal"></i></a>
                    <a
                      className="btn btn-lg btn-primary btn-lg-square rounded"
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fab fa-linkedin-in fw-normal"></i></a>
                  </div>
                </div>
                <div className="text-center py-4">
                  <h4 className="text-primary">Full Name</h4>
                  <p className="text-uppercase m-0">Designation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Team End */}

      {/* Quote Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">
                  Request A Quote
                </h5>
                <h1 className="mb-0">
                  Your Gateway to the Expert Digital Marketing Solutions
                </h1>
              </div>
              <div className="row gx-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-4">
                    <i className="fa fa-reply text-primary me-3"></i>Reply within 24
                    hours
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-4">
                    <i className="fa fa-phone-alt text-primary me-3"></i>24 hrs
                    telephone support
                  </h5>
                </div>
              </div>
              <p className="mb-4 fs-5">
                Have questions, inquiries, or simply want to discuss how our
                digital marketing strategies can elevate your brand? We'd love to
                hear from you! Our team of experienced professionals is here to
                provide personalized solutions tailored to your unique business
                needs. Your success story may start with a simple message – reach
                out now!
              </p>
              <div
                className="d-flex align-items-center mt-2 wow zoomIn"
                data-wow-delay="0.6s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{width: "60px", height: "60px"}}
                >
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="mb-2">Call to ask any question</h5>
                  <h4 className="text-primary mb-0">+971 55 730 6504</h4>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div
                className="bg-primary rounded h-100 d-flex align-items-center p-5 wow zoomIn"
                data-wow-delay="0.9s"
              >
                <form>
                  <div className="row g-3">
                    <div className="col-xl-12">
                      <input
                        type="text"
                        className="form-control bg-light border-0"
                        placeholder="Your Name"
                        style={{height: "55px"}}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="email"
                        className="form-control bg-light border-0"
                        placeholder="Your Email"
                        style={{height: "55px"}}
                      />
                    </div>
                    <div className="col-12">
                      <select
                        className="form-select bg-light border-0"
                        style={{height: "55px"}}
                      >
                        <option defaultValue>Select A Service</option>
                        <option value="1">SEO Services</option>
                        <option value="2">SEM Services</option>
                        <option value="3">Social Media Marketing</option>
                        <option value="4">Web Development</option>
                        <option value="5">Content Writing</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control bg-light border-0"
                        rows="3"
                        placeholder="Message"
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-dark w-100 py-3" type="submit">
                        Request A Quote
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Quote End */}


      <Footer />
    </div>
  );
}

export default About;